import { app } from '../../../bootstrap/core';
import { isBrowser } from './isBrowser.directive';

app.directive('isBrowser', isBrowser);
